<template>
<div>
  <div
    v-if="confirmedBooking && canCancel && languageCode"
    class="row"
  >
    <div
      class="col-12"
    >
      <button
        :disabled="cancelInProgress || disabled"
        class="btn btn-primary btn-block mt-3"
        @click="showCancelConfirm"
      >
        Cancel booking
      </button>
    </div>
    <modal
      :scrollable="true"
      :width="1000"
      height="auto"
      name="booking-cancel-modal"
    >
      <div class="container">
        <div class="row">
          <a
            class="button button--ghost product__info-close"
            @click="hideCancelConfirm"
          ><span class="visuallyhidden">Close</span></a>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <h3>Cancellation Breakdown</h3>
            <div
              v-if="cancellationDetails.cancellationItems.parkings.length > 0"
            >
              <h5 class="mt-1">
                Parking
              </h5>
            </div>
            <table-component
              v-if="cancellationDetails.cancellationItems.parkings.length > 0"
              id="addOnsTable"
              ref="table"
              :data="cancellationDetails.cancellationItems.parkings"
              :show-caption="false"
              :show-filter="false"
              table-class="table table-striped table-bordered"
              thead-class="table-header-sort"
            >
              <table-column
                :sortable="false"
                label="Product Name"
              >
                <template slot-scope="row">
                  {{ product.name }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Amount"
              >
                <template slot-scope="row">
                  {{ $n(row.amount, 'currency', languageCode) }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Can Cancel"
              >
                <template slot-scope="row">
                  <div class="input__checkbox-label">
                    <input
                      :id="'mandatoryCheckbox' + row.id"
                      v-model="row.canCancel"
                      :disabled="true"
                      :class="{ 'is-invalid': $v.cancellationFee.$invalid}"
                      name="mandatoryCheckbox"
                      type="checkbox"
                      class="input__checkbox"
                    >
                    <label
                      :for="'mandatoryCheckbox' + row.id"
                      class="input__checkbox-input"
                    />
                  </div>
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Cancellation Fee"
              >
                <template slot-scope="row">
                  <input
                    v-model="row.cancellationFees"
                    :disabled="!row.canCancel"
                    type="string"
                    class="form-control"
                    autocomplete="off"
                  >
                </template>
              </table-column>
            </table-component>
            <div
              v-if="cancellationDetails.cancellationItems.channelBundles.length > 0"
            >
              <h5 class="mt-1">
                Product
              </h5>
            </div>
            <table-component
              v-if="cancellationDetails.cancellationItems.channelBundles.length > 0"
              id="addOnsTable"
              ref="table"
              :data="cancellationDetails.cancellationItems.channelBundles"
              :show-caption="false"
              :show-filter="false"
              table-class="table table-striped table-bordered"
              thead-class="table-header-sort"
            >
              <table-column
                :sortable="false"
                label="Product Name"
              >
                <template slot-scope="row">
                  {{ product.name }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Amount"
              >
                <template slot-scope="row">
                  {{ $n(row.amount, 'currency', languageCode) }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Can Cancel"
              >
                <template slot-scope="row">
                  <div class="input__checkbox-label">
                    <input
                      :id="'mandatoryCheckbox' + row.extraId"
                      v-model="row.canCancel"
                      :disabled="true"
                      name="mandatoryCheckbox"
                      type="checkbox"
                      class="input__checkbox"
                    >
                    <label
                      :for="'mandatoryCheckbox' + row.extraId"
                      class="input__checkbox-input"
                    />
                  </div>
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Cancellation Fee"
              >
                <template slot-scope="row">
                  <input
                    v-model="row.cancellationFees"
                    :disabled="!row.canCancel"
                    :class="{ 'is-invalid': $v.cancellationFee.$invalid}"
                    type="string"
                    class="form-control"
                    autocomplete="off"
                  >
                </template>
              </table-column>
            </table-component>
            <div
              v-if="cancellationDetails.cancellationItems.extras.length > 0"
            >
              <h5 class="mt-1">
                Ancillaries
              </h5>
            </div>
            <table-component
              v-if="cancellationDetails.cancellationItems.extras.length > 0"
              id="addOnsTable"
              ref="table"
              :data="cancellationDetails.cancellationItems.extras"
              :show-caption="false"
              :show-filter="false"
              table-class="table table-striped table-bordered"
              thead-class="table-header-sort"
            >
              <table-column
                :sortable="false"
                label="Add On Name"
              >
                <template slot-scope="row">
                  {{ getAddOnName(row.extraId) }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Amount"
              >
                <template slot-scope="row">
                  {{ $n(row.amount , 'currency', languageCode) }}
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Can Cancel"
              >
                <template slot-scope="row">
                  <div class="input__checkbox-label">
                    <input
                      :id="'mandatoryCheckbox' + row.extraId"
                      v-model="row.canCancel"
                      :disabled="true"
                      name="mandatoryCheckbox"
                      type="checkbox"
                      class="input__checkbox"
                    >
                    <label
                      :for="'mandatoryCheckbox' + row.extraId"
                      class="input__checkbox-input"
                    />
                  </div>
                </template>
              </table-column>
              <table-column
                :sortable="false"
                label="Cancellation Fee"
              >
                <template slot-scope="row">
                  <input
                    v-model="row.cancellationFees"
                    :disabled="!row.canCancel"
                    :class="{ 'is-invalid': $v.cancellationFee.$invalid}"
                    type="number"
                    class="form-control"
                    autocomplete="off"
                  >
                </template>
              </table-column>
            </table-component>
            <div
              v-if="$v.$invalid"
              class="alert alert-danger"
            >
              <i class="fa fa-times-circle" />
              You must enter a total cancellation charge below {{ $n(maxCharge, 'currency', languageCode) }} with a refund amount equal or greater than {{ $n(0 , 'currency', languageCode) }}
            </div>
          </div>
          <div class="col-12">
            <h3>Cancellation Summary</h3>
            Booking total: <strong>{{ $n(cancellationDetails.cancellationFee.totalBookingAmount, 'currency', languageCode) }}</strong><br>
            <div v-if="cancellationDetails.bookingFee > 0">
              Booking fee: {{ $n(cancellationDetails.bookingFee, 'currency', languageCode) }}
            </div>
            Total Cancellable amount: {{ $n(cancellationDetails.cancellationFee.totalCancellableAmount, 'currency', languageCode) }}<br>
            Total Cancellation fee: {{ $n(cancellationFee, 'currency', languageCode) }}<br>
            Total Refundable amount: <strong>{{ $n(totalRefundAmount, 'currency', languageCode) }}</strong>
          </div>
        </div>
        <div class="col-12">
          <strong>Are you sure you want to cancel this booking?</strong>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <button
              class="btn btn-info mt-4"
              @click="hideCancelConfirm"
            >
              No, close
            </button>
            <button
              :disabled="cancelInProgress || $v.$invalid"
              class="btn btn-danger mt-4 pull-right"
              @click="cancel"
            >
              Yes, cancel booking
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
  <div class="text-danger"  v-if="cancellationDetails && cancellationDetails.hoursBeforeCancellationUnblocked">Cancellation is currently not possible as the payment is still in progress, please try again in {{cancellationDetails.hoursBeforeCancellationUnblocked}} hours.</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ErrorHandling from '../../../lib/error-handling.js'
import { required, minValue, maxValue, between } from 'vuelidate/lib/validators'
const isDecimal = (value) => /^\d*\.?\d*$/.test(value)
import moment from 'moment'

export default {
    name: 'Cancellation',
    props: ['bookingId', 'disabled'],
    data () {
        return {
            cancelInProgress: false,
            cancellationDetails: null
        }
    },
    computed: {
        ...mapState({
            bookingDetail: state => state.booking.bookingDetail,
            product: state => state.booking.product,
            productExtras: state => state.booking.productExtras,
            airports: state => state.airport.airports
        }),
        maxCharge () {
            return this.cancellationDetails.cancellationFee.totalCancellableAmount
        },
        confirmedBooking () {
            return this.bookingDetail !== null
                ? this.bookingDetail.status.toLowerCase() === 'confirmed'
                : false
        },
        airportCode () {
            if (this.product && this.airports) {
                var airports = this.airports.filter(c => c.id === this.product.airportId)
                if (airports && airports.length > 0) {
                    return airports[0].code
                }
            }
            return ''
        },
        canCancel () {
          if (this.cancellationDetails !== null &&
              this.bookingDetail &&
              this.product) {
              if (((this.bookingDetail.channelTypeID !== 8 && (this.cancellationDetails.cancellationFee.totalCancellableAmount !== 0 || this.airportCode.toLowerCase() === 'phj')) 
                  || (this.bookingDetail.channelTypeID === 8 && this.product.totalPrice === 0))
              && (this.cancellationDetails.hoursBeforeCancellationUnblocked === null
                || this.cancellationDetails.hoursBeforeCancellationUnblocked === 0)
              && moment(this.product.entryDate).utc() >=moment().utc()){
                return true
              }
          }
          return false
        },
        totalRefundAmount () {
            if (this.cancellationDetails && this.cancellationDetails.cancellationFee) {
                return this.cancellationDetails.cancellationFee.totalCancellableAmount - this.cancellationFee
            }
            return null
        },
        cancellationFee () {
            let totalFee = 0
            if (this.cancellationDetails.cancellationItems) {
                if (this.cancellationDetails.cancellationItems.parkings && this.cancellationDetails.cancellationItems.parkings.length > 0) {
                    let parkingTotal = '' + this.cancellationDetails.cancellationItems.parkings.map(function (a) { return a.cancellationFees }).reduce((a, b) => (parseFloat(a) + parseFloat(b)))
                    if (!isNaN(parkingTotal) && parkingTotal.trim() !== '') {
                        totalFee = totalFee + parseFloat(parkingTotal)
                    }
                }
                if (this.cancellationDetails.cancellationItems.extras && this.cancellationDetails.cancellationItems.extras.length > 0) {
                    let extraTotal = '' + this.cancellationDetails.cancellationItems.extras.map(function (a) { return a.cancellationFees }).reduce((a, b) => (parseFloat(a) + parseFloat(b)))
                    if (!isNaN(extraTotal) && extraTotal.trim() !== '') {
                        totalFee = totalFee + parseFloat(extraTotal)
                    }
                }
                if (this.cancellationDetails.cancellationItems.channelBundles && this.cancellationDetails.cancellationItems.channelBundles.length > 0) {
                    let bundlesTotal = '' + this.cancellationDetails.cancellationItems.channelBundles.map(function (a) { return a.cancellationFees }).reduce((a, b) => (parseFloat(a) + parseFloat(b)))
                    if (!isNaN(bundlesTotal) && bundlesTotal.trim() !== '') {
                        totalFee = totalFee + parseFloat(bundlesTotal)
                    }
                }
            }
            return totalFee
        },
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        }
    },
    watch: {
        confirmedBooking () {
            if (this.confirmedBooking && this.cancellationDetails === null) { this.populate() }
        }
    },
    created () {
        this.populate()
    },
    validations: {
        cancellationFee: {
            between (value) {
                return between(0, this.maxCharge)(value)
            }
        },
        totalRefundAmount: {
            minValue: minValue(0)
        },
        cancellationDetails: {
            cancellationItems: {
                parkings: {
                    $each: {
                        cancellationFees: {
                            required,
                            between (value) {
                                return between(0, this.maxCharge)(value)
                            },
                            isDecimal
                        }
                    }
                },
                channelBundles: {
                    $each: {
                        cancellationFees: {
                            required,
                            between (value) {
                                return between(0, this.maxCharge)(value)
                            },
                            isDecimal
                        }
                    }
                },
                extras: {
                    $each: {
                        cancellationFees: {
                            required,
                            between (value) {
                                return between(0, this.maxCharge)(value)
                            },
                            isDecimal
                        }
                    }
                }
            }
        }
    },
    methods: {
        async populate () {
            if (this.confirmedBooking) {
                var details = await this.$store.dispatch('setCancellationDetails', this.bookingId)
                this.cancellationDetails = Object.assign({}, details)
                await this.$store.dispatch('getAirports')
            }
        },
        showCancelConfirm () {
            this.$modal.show('booking-cancel-modal', { bookingId: this.bookingId })
        },
        hideCancelConfirm () {
            this.$modal.hide('booking-cancel-modal')
        },
        async cancel () {
            this.cancelInProgress = true
            var forceCancel = true
            var result = await this.$store.dispatch('cancelBooking',
                [
                    this.bookingId,
                    this.cancellationDetails.cancellationItems.parkings,
                    this.cancellationDetails.cancellationItems.extras,
                    this.cancellationDetails.cancellationItems.channelBundles,
                    forceCancel
                ])
            this.$modal.hide('booking-cancel-modal')
            if (result.status === 204) {
                this.$toasted.success('Booking Cancelled')
                this.reloadBookingData()
            } else {
                this.$toasted.error(`Not Cancelled. ${result.data}`)
            }
            //
            this.cancelInProgress = false
        },
        getAddOnName (id) {
            if (this.productExtras) {
                var extra = this.productExtras.filter(c => c.id === id)
                if (extra && extra.length > 0) {
                    return extra[0].name
                }
            }
            return ''
        },
        reloadBookingData () {
            this.$store.dispatch('getBookingType', this.bookingId)
            this.$store.dispatch('getBookingDetail', this.$route.params.bookingId)
            this.$store.dispatch('getBookingHistory', this.$route.params.bookingId)
            this.populate()
            this.$store.dispatch('getCustomer', this.$route.params.bookingId)
            this.$store.dispatch('getFlightDetails', this.$route.params.bookingId)
            this.$store.dispatch('getNotes', this.$route.params.bookingId)
            this.$store.dispatch('getPaymentDetail', this.$route.params.bookingId)
            this.$store.dispatch('getPaymentHistory', this.$route.params.bookingId)
            this.$store.dispatch('getProduct', this.$route.params.bookingId)
            this.$store.dispatch('getProductExtras', this.$route.params.bookingId)
            this.$store.dispatch('getAirports')
            this.$store.dispatch('getVehicle', this.$route.params.bookingId)
            this.$store.dispatch('getAudit', this.$route.params.bookingId)
        }
    }
}
</script>
